import changeFileExtension from '@/lib/filename-extension-modifier'

const generateAgendaItemSpeakerImage = (images) => {
  const getImage = (context, ratio, size) =>
    images?.[`${context}_${ratio}_${size}`]?.[0]

  const image = {
    src: changeFileExtension(getImage('speaker', '1x1', 320)?.url, 'webp'),
    alt: 'Event Agenda Item Speaker Image'
  }

  return image
}

export default generateAgendaItemSpeakerImage
